<template>
    <div class="text-center">
        <span style="white-space: nowrap;">
            {{ setTime(data[fieldKey], 'DD-MM-YYYY : HH:mm:ss') }}
        </span>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';

const utcPlugin = require('dayjs/plugin/utc');
const timezonePlugin = require('dayjs/plugin/timezone');

// Extend dayjs with plugins
dayjs.extend(utcPlugin);
dayjs.extend(timezonePlugin);


export default {
	name: 'DateColumn',
	props: {
		data: {
			type: Object,
			default: () => {},
		},
		fieldKey: {
			type: String,
			default: '',
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
	},
	methods: {
		setTime(date, format) {
			return date ? dayjs.utc(date).tz(this.user?.timezone).format(format) : '-';
		},
	},
};
</script>
